import React from "react";
import "./InputGlobal.scss";

export const InputGlobal = ({
  placeholder,
  className,
  name,
  type,
  onChange,
  id,
  value,
}) => {
  return (
    <input
      autoComplete="off"
      type={type}
      placeholder={placeholder}
      className={className}
      name={name}
      onChange={onChange}
      id={id}
      value={value}
    />
  );
};
